export function getbubbleSort(array,animations) {
    var bool = true, swap;
    let i=0;
    while (bool) {
        swap = false;
        for(let index=0;index<array.length-1-i;index++){
            var adjacent = array[index + 1];
            animations.push([index,index+1]);
            animations.push([index,index+1]);
            if (array[index] > array[index + 1]) {
                animations.push([[index,adjacent],[index+1,array[index]]]);
                array[index + 1] = array[index];
                array[index] = adjacent;
                swap = true;
                
            }
            else{
                animations.push([[index,array[index]],[index+1,adjacent]]);
            }
        }
        if (!swap)
            bool = false;
        i++;
    }
}